// extracted by mini-css-extract-plugin
module.exports = {"checkout-page":"styles_checkout-page__1fzHB","content":"styles_content__O5ZHk","checkout-form":"styles_checkout-form__3deAb"};